import { render, staticRenderFns } from "./CustomersCrm.vue?vue&type=template&id=4c5ccd02"
import script from "./CustomersCrm.vue?vue&type=script&lang=js"
export * from "./CustomersCrm.vue?vue&type=script&lang=js"
import style0 from "./CustomersCrm.vue?vue&type=style&index=0&id=4c5ccd02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports